module.exports = __webpack_public_path__ + "media/images/emblems/Hefenhofen-Blazono-ef1685ce4a8e1851a4738c07baaccd5a.png";